export default __webpack_public_path__ + "static/media/pixels-project-5.3d99e660.webp";